var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "move",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13090",
    "data-name": "Path 13090",
    d: "M16.143,8.143l-.806.806,1.474,1.48h-5.24V5.189l1.48,1.474.806-.806L11,3,8.143,5.857l.806.806,1.48-1.474v5.24H5.189l1.474-1.48-.806-.806L3,11l2.857,2.857.806-.806-1.474-1.48h5.24v5.24l-1.48-1.474-.806.806L11,19l2.857-2.857-.806-.806-1.48,1.474v-5.24h5.24l-1.474,1.48.806.806L19,11Z",
    fill: "#c2c2c2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.e5c8e35b6ddba54df4d9fefddb1192ac.svg";
export { ForwardRef as ReactComponent };